import locationZoneEditComponent from './location_zone.edit.component';

let locationZoneEditModule = angular.module('locationZoneEdit', [])

    .component('locationZoneEdit', locationZoneEditComponent)

    .name;

export default locationZoneEditModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/edit/index.js